var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_ index_ page_fixed_form_control_wrapper_ page_hide_upload_file_list_"},[_c('publicHead'),_c('riskInfo',{ref:"riskInfo",attrs:{"disabledAll":_vm.disabledAll}}),_c('policyInfo',{directives:[{name:"show",rawName:"v-show",value:(_vm.agreementRead),expression:"agreementRead"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }